import React from "react";
import Wrapper from "@/components/shared/Wrapper";


const DashboardKpiCard = ({ value, label, icon: Icon }) => (
  <Wrapper className="!flex-row items-center gap-3 px-5 py-4">
    <div
      className="flex items-center justify-center rounded-[12px] shrink-0"
      style={{ background: "#D8EBF7", width: 39, height: 39, padding: 9 }}
    >
      <Icon size={20} color="var(--color-primary)" />
    </div>
    <div className="flex flex-col gap-0.5">
      <p
        className="font-semibold text-lg leading-tight"
      >
        {value ?? "-"}
      </p>
      <p
        className="font-medium text-sm leading-tight text-blue-300"
      >
        {label}
      </p>
    </div>
  </Wrapper>
);

export default DashboardKpiCard;
